import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { R as z } from "./rounded-box-CXWaE0gJ.mjs";
import { f as d } from "./index-LyFokDcn.mjs";
import { I as H } from "./icon-v2-DGtVEk7e.mjs";
import n from "react";
import { w as W } from "./sizes-DktS74Qp.mjs";
import { m as G } from "./tss-DN0acMKN.mjs";
import { M as b, d as w } from "./constants-CnFYFetN.mjs";
import { B as I } from "./body-text-BiQwh5-U.mjs";
import { u as _ } from "./index-B1qvqCCQ.mjs";
const M = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 18 18", width: "18", height: "18" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement("path", { d: "M9,18 C4.02943725,18 0,13.9705627 0,9 C0,4.02943725 4.02943725,0 9,0 C13.9705627,0 18,4.02943725 18,9 C18,13.9705627 13.9705627,18 9,18 Z M13.5377084,6.03451736 C13.8592866,5.51743694 13.7293983,4.81937837 13.2475549,4.47540748 C12.7636164,4.12918841 12.1152227,4.27082349 11.7946921,4.78677982 L8.18610354,10.596066 L5.91515436,8.97175897 C5.43121592,8.62553991 4.78177473,8.76717498 4.46229157,9.28313132 C4.14071343,9.80021174 4.27060167,10.4982703 4.75244513,10.8422412 L8.76641067,13.7142857 L13.5377084,6.03451736 Z" })
  )
);
M.displayName = "CheckCircle18x18";
const j = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 36 36", width: "36", height: "36" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement(
      "g",
      { fillRule: "nonzero" },
      n.createElement("path", { d: "M18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 Z M27.2801338,9.47259156 C26.4321338,8.75159156 25.1711338,8.86859156 24.4631338,9.73459156 L15.6141338,20.5695916 L11.1091338,17.5055916 C10.1911338,16.8795916 8.94813385,17.1335916 8.33613385,18.0715916 C7.72313385,19.0095916 7.97213385,20.2765916 8.89113385,20.9015916 L16.3861338,26.0005916 L27.5371338,12.3475916 C28.2441338,11.4805916 28.1291338,10.1945916 27.2801338,9.47259156 Z" })
    )
  )
);
j.displayName = "CheckCircle36x36";
const k = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 18 18", width: "18", height: "18" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement("path", { fillRule: "nonzero", d: "M9,0 C4.02975,0 0,4.02975 0,9 C0,13.9725 4.02975,18 9,18 C13.97025,18 18,13.9725 18,9 C18,4.02975 13.97025,0 9,0 Z M8.25,4.5 C8.25,4.086 8.586,3.75 9,3.75 L9,3.75 C9.414,3.75 9.75,4.08525 9.75,4.5 L9.75,9.75 C9.75,10.164 9.414,10.5 9,10.5 L8.99925,10.5 C8.58525,10.5 8.24925,10.16475 8.24925,9.75 L8.24925,4.5 L8.25,4.5 Z M9,14.25 C8.379,14.25 7.875,13.746 7.875,13.125 C7.875,12.504 8.379,12 9,12 C9.621,12 10.125,12.504 10.125,13.125 C10.125,13.746 9.621,14.25 9,14.25 Z" })
  )
);
k.displayName = "CircleExclamation18x18";
const p = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 36 36", width: "36", height: "36" }, e),
  n.createElement("path", { fillRule: "evenodd", d: "M18 0C8.0595 0 0 8.0595 0 18C0 27.945 8.0595 36 18 36C27.9405 36 36 27.945 36 18C36 8.0595 27.9405 0 18 0ZM16.5 9C16.5 8.172 17.172 7.5 18 7.5C18.828 7.5 19.5 8.1705 19.5 9V19.5C19.5 20.328 18.828 21 18 21H17.9985C17.1705 21 16.4985 20.3295 16.4985 19.5V9H16.5ZM15.75 26.25C15.75 27.492 16.758 28.5 18 28.5C19.242 28.5 20.25 27.492 20.25 26.25C20.25 25.008 19.242 24 18 24C16.758 24 15.75 25.008 15.75 26.25Z", clipRule: "evenodd" })
);
p.displayName = "CircleExclamation36x36";
const y = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 18 18", width: "18", height: "18" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement(
      "g",
      null,
      n.createElement("path", { d: "M562,312 C557.02975,312 553,316.0275 553,321 C553,325.97025 557.02975,330 562,330 C566.97025,330 571,325.97025 571,321 C571,316.0275 566.97025,312 562,312 Z M562.75,325.5 C562.75,325.914 562.414,326.25 562,326.25 C561.586,326.25 561.25,325.914 561.25,325.5 L561.25,320.25 C561.25,319.836 561.586,319.5 562,319.5 C562.414,319.5 562.75,319.836 562.75,320.25 L562.75,325.5 Z M562,318 C561.379,318 560.875,317.496 560.875,316.875 C560.875,316.254 561.379,315.75 562,315.75 C562.621,315.75 563.125,316.254 563.125,316.875 C563.125,317.496 562.621,318 562,318 Z", transform: "translate(-553 -312)" })
    )
  )
);
y.displayName = "CircleInfo18x18";
const Z = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 36 36", width: "36", height: "36" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement(
      "g",
      { fillRule: "nonzero" },
      n.createElement("path", { d: "M18,0 C8.0595,0 0,8.055 0,18 C0,27.9405 8.0595,36 18,36 C27.9405,36 36,27.9405 36,18 C36,8.055 27.9405,0 18,0 Z M19.5,27 C19.5,27.828 18.828,28.5 18,28.5 C17.172,28.5 16.5,27.828 16.5,27 L16.5,16.5 C16.5,15.672 17.172,15 18,15 C18.828,15 19.5,15.672 19.5,16.5 L19.5,27 Z M18,12 C16.758,12 15.75,10.992 15.75,9.75 C15.75,8.508 16.758,7.5 18,7.5 C19.242,7.5 20.25,8.508 20.25,9.75 C20.25,10.992 19.242,12 18,12 Z" })
    )
  )
);
Z.displayName = "CircleInfo36x36";
const B = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 16 15", width: "16", height: "15" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement("path", { fillRule: "nonzero", d: "M15.6746518,11.2499148 C16.6046721,12.9210891 15.4299797,15 13.5559388,15 L2.44369621,15 C0.570321969,15 -0.604370346,12.9210891 0.324983279,11.2499148 L5.88110459,1.26309689 C6.81779171,-0.421032296 9.18184333,-0.421032296 10.1185304,1.26309689 L15.6746518,11.2499148 Z M7.99981752,12.954499 C8.55182957,12.954499 8.99983935,12.4963067 8.99983935,11.9317484 C8.99983935,11.3671902 8.55182957,10.9089979 7.99981752,10.9089979 C7.44780546,10.9089979 6.99979568,11.3671902 6.99979568,11.9317484 C6.99979568,12.4963067 7.44780546,12.954499 7.99981752,12.954499 Z M8,4 C7.44771525,4 7,4.44771525 7,5 L7,9 C7,9.55228475 7.44771525,10 8,10 C8.55228475,10 9,9.55228475 9,9 L9,5 C9,4.44771525 8.55228475,4 8,4 Z" })
  )
);
B.displayName = "TriangleExclamation16x16";
const N = (e) => n.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 36 33", width: "36", height: "33" }, e),
  n.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    n.createElement(
      "g",
      { fillRule: "nonzero" },
      n.createElement("path", { d: "M35.2679665,26.7498125 L22.7666935,4.77881315 C20.6591475,1.07372895 15.3400313,1.07372895 13.2324853,4.77881315 L0.731212377,26.7498125 C-1.35983328,30.4263961 1.28322443,35 5.49831646,35 L30.5008624,35 C34.7174544,35 37.3605121,30.4263961 35.2679665,26.7498125 Z M16.4995567,10.9994545 C16.4995567,10.1714357 17.1715713,9.49942044 17.9995894,9.49942044 L17.9995894,9.49942044 C18.8276075,9.49942044 19.4996222,10.1699357 19.4996222,10.9994545 L19.4996222,21.4996932 C19.4996222,22.327712 18.8276075,22.9997273 17.9995894,22.9997273 L17.9980894,22.9997273 C17.1700713,22.9997273 16.4980566,22.329212 16.4980566,21.4996932 L16.4980566,10.9994545 L16.4995567,10.9994545 Z M17.9995894,30.4998977 C16.7575623,30.4998977 15.7495403,29.4918748 15.7495403,28.2498466 C15.7495403,27.0078184 16.7575623,25.9997954 17.9995894,25.9997954 C19.2416165,25.9997954 20.2496385,27.0078184 20.2496385,28.2498466 C20.2496385,29.4918748 19.2416165,30.4998977 17.9995894,30.4998977 Z", transform: "translate(0 -2)" })
    )
  )
);
N.displayName = "TriangleExclamation36x36";
var a = /* @__PURE__ */ ((e) => (e.error = "error", e.success = "success", e.warning = "warning", e.info = "info", e.neutral = "neutral", e.discovery = "discovery", e))(a || {}), x = /* @__PURE__ */ ((e) => (e.default = "default", e.light = "light", e))(x || {});
const O = {
  CheckCircle18x18: M,
  CheckCircle36x36: j,
  CircleExclamation18x18: k,
  CircleExclamation36x36: p,
  CircleInfo18x18: y,
  CircleInfo36x36: Z,
  TriangleExclamation16x16: B,
  TriangleExclamation36x36: N
}, f = (e, r) => {
  const t = O[e];
  return /* @__PURE__ */ i.jsx(t, { fill: r });
}, h = (e, r) => /* @__PURE__ */ i.jsx(H, { color: r, name: e, size: 16 }), L = (e, r) => {
  const { icon: t, status: o, description: g } = e, l = g ? "36x36" : "18x18";
  if (t === void 0)
    switch (o) {
      case a.discovery:
        return d.ifFeature("encore", h("gift-solid", "discovery-strong"));
      case a.error:
        return d.ifFeature(
          "encore",
          h("circle-exclamation-solid", "error-strong"),
          f(`CircleExclamation${l}`, r.error.main)
        );
      case a.info:
        return d.ifFeature(
          "encore",
          h("circle-info-solid", "info-strong"),
          f(`CircleInfo${l}`, r.info.main)
        );
      case a.success:
        return d.ifFeature(
          "encore",
          h("circle-check-solid", "success-strong"),
          f(`CheckCircle${l}`, r.success.main)
        );
      case a.warning:
        return d.ifFeature(
          "encore",
          h("triangle-exclamation-solid", "warning-strong"),
          f(`TriangleExclamation${l}`, r.warning.main)
        );
      default:
        return d.ifFeature("encore", void 0, f(`CircleInfo${l}`, r.gray[800]));
    }
  else if (typeof t == "string")
    return d.ifFeature("encore", h(t, o ? `${o}-strong` : "neutral-extra-strong"));
  return t;
}, F = (e, r, t) => {
  if (e === x.light)
    return t.background.default;
  switch (r) {
    case a.error:
      return t.error.light;
    case a.info:
      return t.info.light;
    case a.success:
      return t.success.light;
    case a.warning:
      return t.warning.light;
    default:
      return t.gray[100];
  }
}, S = G({ name: "InlineMessage" })(({ palette: e, borderRadiuses: r, typography: t, spacing: o, mode: g }, { isFullSize: l, description: m, status: s, variant: u, width: C }) => {
  const v = C ? W[C] : "auto";
  return d.ifFeature(
    "encore",
    {
      action: {
        alignItems: "center",
        display: "flex",
        height: o(4),
        paddingLeft: o(2.5)
      },
      container: {
        backgroundColor: u === x.light ? e.common.white : s === a.neutral ? e.gray[100] : e[s].light,
        borderRadius: r[200],
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "row",
        flexGrow: C ? 1 : 0,
        padding: o(1.5)
      },
      icon: {
        alignItems: "flex-start",
        display: "flex",
        flexShrink: 0,
        justifyContent: "center",
        marginRight: o(1),
        minWidth: 16,
        paddingTop: o(0.25)
      },
      root: {
        display: C ? "flex" : "inline-block",
        outline: g === b.Dye ? `2px solid ${w.main}` : void 0,
        width: C === 100 ? "100%" : v
      },
      content: {
        flexGrow: 1
      },
      description: {},
      title: {}
    },
    {
      action: {},
      container: {
        alignItems: "start",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "start",
        minHeight: l ? 60 : 35,
        padding: l ? "8px 14px" : "7px 12px"
      },
      content: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        lineHeight: t.medium.lineHeight
      },
      description: {
        color: e.gray[u === x.light ? 800 : 900],
        fontSize: t.small.fontSize,
        fontWeight: t.fontWeightRegular
      },
      icon: {
        alignItems: "center",
        display: "flex",
        height: l ? 44 : 22,
        justifyContent: "center",
        marginRight: o(m ? 1.75 : 1),
        maxWidth: l ? 36 : 18
      },
      root: {
        display: "inline-block",
        outline: g === b.Dye ? `2px solid ${w.main}` : void 0
      },
      title: {
        color: e.gray[1e3],
        fontSize: t.medium.fontSize,
        fontWeight: t.fontWeightSemibold
      }
    }
  );
});
function X(e) {
  const {
    action: r,
    ariaLabel: t,
    biId: o,
    icon: g,
    id: l,
    title: m,
    description: s,
    status: u = a.neutral,
    variant: C = x.default,
    width: v
  } = e, { palette: E } = _(), { classes: c } = S({ description: s, isFullSize: !!(m && s), status: u, variant: C, width: v }), $ = g !== !1 && m, R = g === !1 ? null : L(e, E);
  return /* @__PURE__ */ i.jsx(
    "div",
    {
      "aria-label": t,
      className: c.root,
      "data-bi-id": o,
      "data-fabric-component": "InlineMessage",
      id: l,
      role: "region",
      children: d.ifFeature(
        "encore",
        /* @__PURE__ */ i.jsxs("div", { className: c.container, children: [
          R ? /* @__PURE__ */ i.jsx("div", { className: c.icon, children: R }) : null,
          /* @__PURE__ */ i.jsxs("div", { className: c.content, children: [
            m ? /* @__PURE__ */ i.jsx(I, { color: u ? `${u}-strong` : void 0, size: "small", weight: "semibold", children: m }) : null,
            s ? /* @__PURE__ */ i.jsx(I, { size: "extra-small", children: s }) : null
          ] }),
          r ? /* @__PURE__ */ i.jsx("div", { className: c.action, children: r }) : null
        ] }),
        /* @__PURE__ */ i.jsx(z, { backgroundColor: F(C, u, E), borderRadius: 4, padding: "0", children: /* @__PURE__ */ i.jsxs("div", { className: c.container, children: [
          $ ? /* @__PURE__ */ i.jsx("div", { className: c.icon, children: L(e, E) }) : null,
          /* @__PURE__ */ i.jsxs("div", { className: c.content, children: [
            m ? /* @__PURE__ */ i.jsx("div", { className: c.title, children: m }) : null,
            s ? /* @__PURE__ */ i.jsx("div", { className: c.description, children: s }) : null
          ] })
        ] }) })
      )
    }
  );
}
export {
  X as I,
  a,
  k as b,
  j as c,
  N as d,
  x as e
};
//# sourceMappingURL=inline-message-BYLpwrsI.mjs.map
